export class ReconnectCustomerVaultAccountResponse {
    'customerVaultAccount';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "customerVaultAccount",
            "baseName": "customerVaultAccount",
            "type": "CustomerVaultAccount",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ReconnectCustomerVaultAccountResponse.attributeTypeMap;
    }
    constructor() {
    }
}
